// frontend/src/components/CredentialsModal.tsx

import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import Modal from "./ui/Modal";

interface CredentialsModalProps {
  isOpen: boolean;
  onClose: () => void;
  credentials: {
    username: string;
    password: string;
  };
}

const CredentialsModal: React.FC<CredentialsModalProps> = ({
  isOpen,
  onClose,
  credentials,
}) => {
  const [copyStatus, setCopyStatus] = useState<"idle" | "copied">("idle");

  const handleCopyCredentials = async () => {
    const formattedText = `Username: ${credentials.username}\nPassword: ${credentials.password}`;
    await navigator.clipboard.writeText(formattedText);
    setCopyStatus("copied");
    setTimeout(() => setCopyStatus("idle"), 2000);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="New User Credentials"
      maxWidth="sm"
    >
      <div className="space-y-6">
        <div className="bg-gray-50 p-6 rounded-lg space-y-3 font-mono text-sm">
          <div className="flex gap-2">
            <span className="text-gray-500">Username:</span>
            <span>{credentials.username}</span>
          </div>
          <div className="flex gap-2">
            <span className="text-gray-500">Password:</span>
            <span>{credentials.password}</span>
          </div>
        </div>

        <div className="flex justify-center gap-3 pt-2">
          <button
            onClick={handleCopyCredentials}
            className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            {copyStatus === "idle" ? (
              <>
                <Copy size={16} />
                Copy Credentials
              </>
            ) : (
              <>
                <Check size={16} />
                Copied!
              </>
            )}
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2.5 text-sm font-medium text-gray-600 border rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center leading-relaxed p-1">
          Make sure to save these credentials in a secure location.
          <br />
          You won't be able to see them again.
          <br />
        </p>
      </div>
    </Modal>
  );
};

export default CredentialsModal;
